import { MAX_INSURANCE_DIFF } from '../form/settings';

const isDateWithinOneYearUtil = (dateStr: string | null | undefined): boolean => {
  if (!dateStr) {
    return false;
  }

  const inputDate = new Date(dateStr);

  if (isNaN(inputDate.getTime())) {
    return false;
  }

  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + MAX_INSURANCE_DIFF);

  const inputYear = inputDate.getFullYear();
  const inputMonth = inputDate.getMonth();
  const inputDay = inputDate.getDate();

  const maxYear = maxDate.getFullYear();
  const maxMonth = maxDate.getMonth();
  const maxDay = maxDate.getDate();

  if (inputYear < maxYear) {
    return true;
  } else if (inputYear === maxYear && inputMonth < maxMonth) {
    return true;
  } else if (inputYear === maxYear && inputMonth === maxMonth && inputDay <= maxDay) {
    return true;
  }

  return false;
};

export default isDateWithinOneYearUtil;
